/**
 * Created by mestrad on 2018. 06. 29..
 */

export default searchRequest;
import ResultList from "./Result";
import AjaxRequest from "../Ajax";
import Style from "../Style";

const $ = jQuery;

function searchRequest ( config )
{
    var formCustomFilter;
    var $form = $( config.domElements.searchForm );
    var request;
    var ajaxUrl;
    init();

    function init()
    {
        ajaxUrl = $form.data("ajax-url");
        createRequest();
    }

    function createRequest()
    {
        if(!$(config.domElements.wrapperSelector).hasClass("nnpHidden")){
            formCustomFilter = $form.data("custom_filter");
            var memorialClassFilter = {
                type: 'memorial_classification_type',
                items: [memorialClass]
            };
            if (!!memorialClass) {
                formCustomFilter.hasOwnProperty('nnp_search_types') ?
                formCustomFilter.nnp_search_types.push(memorialClassFilter)
                                                                    : formCustomFilter.nnp_search_types = [memorialClassFilter];
            }
        }

        var $searchInput = $( config.domElements.searchInput).val();

        request = {
            url: ajaxUrl + "/" + $form.data("action"),
            data: {
                action: $form.data("action"),
                extra_filter: JSON.stringify(formCustomFilter),
                object_type: config.objectType,
                search: !!$searchInput ? $searchInput.replace(/[-.]/g, ' ') : $searchInput,
                locale: config.locale,
                page: config.page,
                limit: config.limit,
                order_field: config.orderField || 'relevance',
                order_type: config.orderType || 'asc'
            },
            success: function(response) {
                if( response.success ) {
                    var viewType = "namecard";
                    if($(".nnpResultListViewChanger").length > 0){
                        viewType = $(".nnpResultListViewChanger input:checked").val();
                    }
                    $.extend(config, {view: viewType});
                    ResultList(response.data, config);
                }
            }
        };
        /*
        if ( config.orderType != undefined || config.orderType != 0 ) {
            $.extend( request.data, { order_field: config.orderField } );
            $.extend( request.data, { order_type: config.orderType } );
        }
         */
        Style.show( $(config.domElements.searchWidget) );
        $("#nnp_search").val($( config.domElements.searchInput).val());
        Style.show( $(config.domElements.resultListWidget ) );
        AjaxRequest(request);
    }
}
